const Q = require('q');
const userContext = require('core/userContext');
const accountService = require('services/accountService');
const model = require('model/model');
// const { setGCClassList } = require('utilities/googleClassroomUtilities');
const page = require('page');

const get = () => {
	let account = model.get('account');
	let userContextModel = model.get('userContext');
	if (!account || account.email !== userContextModel.email) {
		return accountService.teacherGetAccount().then(resp => {
			model.set('account', resp);
			return resp;
		});
	} else {
		return Q(account);
	}
};

const update = data => {
	return get().then(account => {
		return accountService.teacherUpdateAccount(data).then(result => {
			const experiments = result?.experiments ?? [];
			userContext.updateExperiments(experiments);

			userContext.updateCampaign(result.campaign);

			account = { ...account, ...result.updated };
			model.set('account', account);

			return account;
		});
	});
};

const clear = () => {
	model.remove('account');
};

const getFromToken = async token => {
	if (!token) {
		return;
	}

	userContext.initialize({
		token
	});

	const account = await get();
	account.token = token;

	userContext.initialize(account);

	const newURL = new URL(location.href);

	if (account.google) {
		const ssoToken = newURL.searchParams.get('token');

		if (ssoToken) {
			model.set('localGCAccessToken', ssoToken);
			// setGCClassList(ssoToken);

			// remove token from url
			newURL.searchParams.delete('token');
			page(`${newURL.pathname}${newURL.search}`);
		}
	}
};

module.exports = {
	get,
	getFromToken,
	update,
	clear
};
